import { IHoliday } from "../holidayTypes";

export const FranceHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Jour de l'An", type: "HOLIDAY" },
  "2024-03-29": { title: "Vendredi Saint", type: "SPECIAL_DAY" }, // Endast i vissa delar
  "2024-04-01": { title: "Lundi de Pâques", type: "HOLIDAY" },
  "2024-05-01": { title: "Fête du Travail", type: "HOLIDAY" },
  "2024-05-08": { title: "Fête de la Victoire", type: "HOLIDAY" },
  "2024-05-09": { title: "Ascension", type: "HOLIDAY" },
  "2024-05-19": { title: "Pentecôte", type: "HOLIDAY" },
  "2024-05-20": { title: "Lundi de Pentecôte", type: "HOLIDAY" },
  "2024-07-14": { title: "Fête Nationale", type: "HOLIDAY" },
  "2024-08-15": { title: "Assomption", type: "HOLIDAY" },
  "2024-11-01": { title: "Toussaint", type: "HOLIDAY" },
  "2024-11-11": { title: "Jour d'Armistice", type: "HOLIDAY" },
  "2024-12-25": { title: "Noël", type: "HOLIDAY" },
  "2024-12-26": { title: "Saint Étienne", type: "SPECIAL_DAY" }, // Endast i Alsace och Moselle

  // 2025
  "2025-01-01": { title: "Jour de l'An", type: "HOLIDAY" },
  "2025-02-14": { title: "Saint-Valentin", type: "SPECIAL_DAY" },
  "2025-04-18": { title: "Vendredi Saint", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2025-04-21": { title: "Lundi de Pâques", type: "HOLIDAY" },
  "2025-05-01": { title: "Fête du Travail", type: "HOLIDAY" },
  "2025-05-08": { title: "Fête de la Victoire", type: "HOLIDAY" },
  "2025-05-29": { title: "Ascension", type: "HOLIDAY" },
  "2025-06-08": { title: "Pentecôte", type: "SPECIAL_DAY" },
  "2025-06-09": { title: "Lundi de Pentecôte", type: "HOLIDAY" },
  "2025-07-14": { title: "Fête Nationale", type: "HOLIDAY" },
  "2025-08-15": { title: "Assomption", type: "HOLIDAY" },
  "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2025-11-01": { title: "Toussaint", type: "HOLIDAY" },
  "2025-11-11": { title: "Jour d'Armistice", type: "HOLIDAY" },
  "2025-12-24": { title: "Réveillon de Noël", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Noël", type: "HOLIDAY" },
  "2025-12-26": { title: "Saint Étienne", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2025-12-31": { title: "Réveillon de Nouvel An", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Jour de l'An", type: "HOLIDAY" },
  "2026-02-14": { title: "Saint-Valentin", type: "SPECIAL_DAY" },
  "2026-04-03": { title: "Vendredi Saint", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2026-04-06": { title: "Lundi de Pâques", type: "HOLIDAY" },
  "2026-05-01": { title: "Fête du Travail", type: "HOLIDAY" },
  "2026-05-08": { title: "Fête de la Victoire", type: "HOLIDAY" },
  "2026-05-14": { title: "Ascension", type: "HOLIDAY" },
  "2026-05-24": { title: "Pentecôte", type: "SPECIAL_DAY" },
  "2026-05-25": { title: "Lundi de Pentecôte", type: "HOLIDAY" },
  "2026-07-14": { title: "Fête Nationale", type: "HOLIDAY" },
  "2026-08-15": { title: "Assomption", type: "HOLIDAY" },
  "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2026-11-01": { title: "Toussaint", type: "HOLIDAY" },
  "2026-11-11": { title: "Jour d'Armistice", type: "HOLIDAY" },
  "2026-12-24": { title: "Réveillon de Noël", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Noël", type: "HOLIDAY" },
  "2026-12-26": { title: "Saint Étienne", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2026-12-31": { title: "Réveillon de Nouvel An", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Jour de l'An", type: "HOLIDAY" },
  "2027-02-14": { title: "Saint-Valentin", type: "SPECIAL_DAY" },
  "2027-03-26": { title: "Vendredi Saint", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2027-03-29": { title: "Lundi de Pâques", type: "HOLIDAY" },
  "2027-05-01": { title: "Fête du Travail", type: "HOLIDAY" },
  "2027-05-06": { title: "Ascension", type: "HOLIDAY" },
  "2027-05-08": { title: "Fête de la Victoire", type: "HOLIDAY" },
  "2027-05-16": { title: "Pentecôte", type: "SPECIAL_DAY" },
  "2027-05-17": { title: "Lundi de Pentecôte", type: "HOLIDAY" },
  "2027-07-14": { title: "Fête Nationale", type: "HOLIDAY" },
  "2027-08-15": { title: "Assomption", type: "HOLIDAY" },
  "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
  "2027-11-01": { title: "Toussaint", type: "HOLIDAY" },
  "2027-11-11": { title: "Jour d'Armistice", type: "HOLIDAY" },
  "2027-12-24": { title: "Réveillon de Noël", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Noël", type: "HOLIDAY" },
  "2027-12-26": { title: "Saint Étienne", type: "SPECIAL_DAY" }, // Endast Alsace och Moselle
  "2027-12-31": { title: "Réveillon de Nouvel An", type: "SPECIAL_DAY" }
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/franceHolidays.ts